import React from 'react';
import { articleMeta } from '../data/article';
export function ArticleHero() {
  return <header className="border-b border-rule pb-8" data-id="element-5" data-mp="2xjephojs8ueq">
      <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.2em] text-ink-muted" data-id="element-6" data-mp="2xkpt9od8a25u">
        {articleMeta.kicker}
      </p>

      <h1 className="mt-5 max-w-[24ch] font-serif text-[34px] font-bold leading-[1.1] tracking-[-0.015em] text-ink sm:text-[44px] lg:text-[54px]" data-id="element-7" data-mp="36jup2mxenheb">
        {articleMeta.headline}
      </h1>

      <p className="mt-6 max-w-read font-serif text-[19px] leading-[1.6] text-ink-soft sm:text-[21px]" data-id="element-8" data-mp="3ghqynaap24ab">
        {articleMeta.standfirst}
      </p>

      <div className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-1" data-id="element-9" data-mp="3u7uhdrad7fv0">
        <span className="font-sans text-[13px] font-semibold text-ink" data-id="element-10" data-mp="3p9kndk0dmlaz">
          {articleMeta.publication}
        </span>
        <span aria-hidden="true" className="h-3 w-px bg-rule-strong" data-id="element-11" data-mp="82qt68mcu4h7" />
        <span className="font-sans text-[13px] text-ink-muted" data-id="element-12" data-mp="33e6pozeazf5">{articleMeta.domain}</span>
      </div>
    </header>;
}